import {ParamsModel} from 'src/app/modules/common/Model'
import {IExportFileState} from 'src/app/modules/network/components/branchless'
import {DeleteGrievanceModal} from '../Model'
import {actionTypes} from './constants'

export const actions = {
  // get ServiceType DATA
  getEnquiry: (params: ParamsModel | {status: number} = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_ENQUIRY_START,
    payload: params,
  }),
  getEnquirySuccess: (data: any) => ({
    type: actionTypes.GET_ENQUIRY_SUCCESS,
    payload: data,
  }),
  getEnquiryFinish: () => ({
    type: actionTypes.GET_ENQUIRY_FINISH,
  }),

  // delete key
  deleteEnquiry: (data: DeleteGrievanceModal[]) => ({
    type: actionTypes.DELETE_ENQUIRY_START,
    payload: {queryId: data},
  }),
  deleteEnquirySuccess: (data: any) => ({
    type: actionTypes.DELETE_ENQUIRY_SUCCESS,
    payload: data,
  }),
  deleteEnquiryFinish: () => ({
    type: actionTypes.DELETE_ENQUIRY_FINISH,
  }),

  //Export file csv
  exportFile: (fileName: string, params: ParamsModel) => {
    return {
      type: actionTypes.EXPORT_ENQUIRY_FILE_START,
      payload: {fileName, params},
    }
  },

  exportFileSuccess: (data: IExportFileState) => ({
    type: actionTypes.EXPORT_ENQUIRY_FILE_SUCCESS,
    payload: data,
  }),
  exportFileError: () => ({
    type: actionTypes.EXPORT_ENQUIRY_FILE_FINISH,
  }),
}
